import type {Organization} from '~/types/api';

const E2E_VISUAL_TEST_ORG_ID = 'e2e-visual-test-org-id';

const mockOrg: Organization = {
  id: 1,
  name: 'E2E Visual Test Org',
  created_at: '2024-01-01T00:00:00.000Z',
  domain: null,
  stripe_customer_id: 'cus_e2e_visual_test',
  stripe_subscription_id: 'sub_e2e_visual_test',
  propelauth_id: 'pa_e2e_visual_test',
  uuid: E2E_VISUAL_TEST_ORG_ID,
  is_pixel_installed: false,
  is_pixel_fallback_enabled: false,
  svix_app_id: null,
  svix_integration_key: null,
  settings: {
    isDemoOrg: true,
  },
  in_market_topics: [],
  is_disabled: false,
  disabled_at: null,
  disabled_reason: null,
  subscription: {
    items: {
      data: [
        {
          price: {
            product: 'prod_QhnUryTPVYCPED',
            id: 'price_1Qybm2L9PCat5EZ70qAhn7lk',
            recurring: {interval: 'year'},
          },
          quantity: 1,
        },
      ],
    },
    current_period_end: 1893456000,
  },
} as unknown as Organization;

const mockUser = {
  userId: 'e2e-visual-test-user-id',
  email: 'e2e@visual-test.local',
  firstName: 'E2E',
  lastName: 'Tester',
  createdAt: '2024-01-01T00:00:00.000Z',
  loginMethod: 'password',
  loginCount: 1,
  lastLoginAt: '2024-01-01T00:00:00.000Z',
};

const mockOrgHelper = {
  getOrgs: () => [{orgId: E2E_VISUAL_TEST_ORG_ID, orgName: mockOrg.name}],
};

const mockPropelAuth = {
  getAuthenticationInfoOrNull: async () => ({
    user: mockUser,
    orgHelper: mockOrgHelper,
    accessToken: 'e2e-visual-test-fake-token',
  }),
  getAccessTokenForOrg: async (_orgId: string) => ({
    accessToken: 'e2e-visual-test-fake-token',
  }),
  redirectToLoginPage: () => {
    /* no-op in test mode */
  },
  redirectToAccountPage: () => {
    /* no-op in test mode */
  },
  redirectToOrgPage: () => {
    /* no-op in test mode */
  },
  logout: () => {
    /* no-op in test mode */
  },
  addLoggedInChangeObserver: () => {
    /* no-op in test mode */
  },
};

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig();
  const e2eVisualTest = !!config.public.e2eVisualTest;

  if (!e2eVisualTest) return;

  nuxtApp.hook('app:created', () => {
    useState<Organization>('org', () => mockOrg);
  });

  return {
    provide: {
      propelAuth: mockPropelAuth,
    },
  };
});
